import { render, staticRenderFns } from "./assetChangeList.vue?vue&type=template&id=17744788"
import script from "./assetChangeList.vue?vue&type=script&lang=js"
export * from "./assetChangeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports